import { render, staticRenderFns } from "./Alimentos.vue?vue&type=template&id=b7d93cb2&scoped=true&lang=pug"
import script from "./Alimentos.vue?vue&type=script&lang=js"
export * from "./Alimentos.vue?vue&type=script&lang=js"
import style0 from "./Alimentos.styl?vue&type=style&index=0&id=b7d93cb2&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d93cb2",
  null
  
)

export default component.exports